import { IEventTranslate } from "@veritas-dumpsters/models/event-translate.models";

export const eventTranslates: IEventTranslate[] = [
  { type: 'AddChildDumpster', translate: '$lbl.addChildDumpster' },
  { type: 'RemoveChildDumpster', translate: '$lbl.removeChildDumpster' },
  { type: 'AddParentDumpster', translate: '$lbl.addParentDumpsterEvent' },
  { type: 'RemoveParentDumpster', translate: '$lbl.removeChildDumpsterEvent' },
  { type: 'AddDumpster', translate: '$lbl.addDumpster' },
  { type: 'AutoRegistration', translate: '$lbl.autoRegistration' },
]